import { Box, Divider, Popover, Typography } from "@mui/material";
import axios from "axios";
import LineGraphTwoLine from "components/Reports/ReusableComponents/LineGraphTwoLine/LineGraphTwoLine";
import { GlobalState } from "context/GlobalContext";
import { ReportsState } from "context/ReportsContext";
import { useEffect, useState } from "react";
import parseErrMsgFromError from "utils/errorFunctions/parseErrorMessageFromError";
import {
	colorFilterCol,
	getSaleImFields,
	imFilterColumnsObj,
	lineGraphTypes,
	locationFilterColumns,
	storeFilterColumns,
	styleFilterCol,
	xAxisMonthDataCol,
} from "./data";
import FilterDrawer from "components/Reports/ReusableComponents/FilterDrawer/FilterDrawer";
import CustomDateRangePicker from "components/Reports/ReusableComponents/CustomDateRangePicker/CustomDateRangePicker";
import { endOfYear, startOfDay, startOfYear, subDays, subYears } from "date-fns";
import AreaGraphTwoLine from "components/Reports/ReusableComponents/AreaGraphTwoLine/AreaGraphTwoLine";
import RenderAttributes from "components/Reports/ReusableComponents/RenderAttributes/RenderAttributes";
import { arrType, inputTypes, isColumnDefault, selectOptKeyName } from "data/globalData";
import SearchInputFieldWithDebounce from "components/Reports/ReusableComponents/SearchInputFieldWithDebounce/SearchInputFieldWithDebounce";

const dateStaticRanges = [
	{
		label: "Last 3 Months",
		range: () => {
			const end = startOfDay(new Date());
			const start = startOfDay(subDays(end, 89));
			return { startDate: start, endDate: end };
		},
		isSelected: (range) => {
			const end = startOfDay(new Date()).getTime();
			const start = startOfDay(subDays(new Date(), 89)).getTime();
			return range.startDate.getTime() === start && range.endDate.getTime() === end;
		},
	},
	{
		label: "Last 6 Months",
		range: () => {
			const end = startOfDay(new Date());
			const start = startOfDay(subDays(end, 179));
			return { startDate: start, endDate: end };
		},
		isSelected: (range) => {
			const end = startOfDay(new Date()).getTime();
			const start = startOfDay(subDays(new Date(), 364)).getTime();
			return range.startDate.getTime() === start && range.endDate.getTime() === end;
		},
	},
	{
		label: "Last Year",
		range: () => {
			const start = startOfYear(subYears(new Date(), 1));
			const end = endOfYear(subYears(new Date(), 1));
			return { startDate: start, endDate: end };
		},
		isSelected: (range) => {
			const start = startOfYear(subYears(new Date(), 1)).getTime();
			const end = endOfYear(subYears(new Date(), 1)).getTime();
			return range.startDate.getTime() === start && range.endDate.getTime() === end;
		},
	},
];
const removeDropdownOptionsBasedonDependency = (column, data, options, allColumns) => {
	if ((column?.input_type === inputTypes.SELECT.key || column?.input_type === inputTypes.MULTIPLE_SELECT.key) && options) {
		let list = [];
		console.log(column, options, "columnsd.........");

		let dependentCols = [];
		if (column?.dependency)
			Object.keys(column?.dependency).forEach((colKey) => {
				dependentCols.push(allColumns.filter((row) => row.key === colKey)[0]);
			});
		console.log(dependentCols, column, "agfajfgdjfgujydfqjdhtg");
		if (dependentCols?.length) {
			column[selectOptKeyName]?.list?.forEach((attrVal) => {
				let push = true;
				dependentCols.forEach((col) => {
					// console.log("Checking column:", col.key, "Input Type:", col.input_type);
					// console.log("data[col.key]:", data[col.key]);
					if (data?.[col.key] && !isColumnDefault(col, data?.[col.key]))
						if (col.input_type === inputTypes.SELECT.key) {
							// console.log("Inside SELECT condition!");

							if (attrVal?.[col.key] === data?.[col.key]) {
							} else push = false;
						} else if (col.input_type === inputTypes.MULTIPLE_SELECT.key) {
							if (data?.[col.key]?.includes(attrVal?.[col.key])) {
							} else push = false;
						} else push = false;
				});
				if (push) list.push(attrVal);
			});
		} else list = column[selectOptKeyName];

		console.log("kjdfnjlasjdn", list, column);
		if (Array.isArray(list))
			return {
				type: arrType,
				list: [...new Set(list?.map((val) => val?.[column.key]))].map((row) => {
					return { name: row, key: row };
				}),
			};
		else
			return {
				type: arrType,
				list: [...new Set(list?.list?.map((val) => val?.[column.key]))].map((row) => {
					return { name: row, key: row };
				}),
			};
	} else return {};
};

const SaleSummary = () => {
	const { setSnackBarOpen, setSnackBar, snackbar } = GlobalState();
	const { reportLoading, setReportLoading, saleImDropdowns, setSaleImDropdowns } = ReportsState();

	const [filter, setFilter] = useState({});
	const [imFilterColumns, setImFilterColumns] = useState(Object.values(imFilterColumnsObj));

	const getLast3MDate = () => {
		const end = startOfDay(new Date());
		const start = startOfDay(subDays(end, 29));
		return { startDate: start, endDate: end };
	};
	const defaultDateRange = {
		...getLast3MDate(),
		key: "selection",
	};
	const [dateRange, setDateRange] = useState(defaultDateRange);
	const [pageData, setPageData] = useState();
	const [filterOpen, setFilterOpen] = useState(false);

	const fetch = async () => {
		try {
			setReportLoading(true);
			const body = {
				filter: { ...filter, ...dateRange },
			};
			const {
				data: {
					result: { tyData, lyData, ...rest },
					...restData
				},
			} = await axios.post(`/api/reports/get-ty-ly-monthly-sale-kpi`, body);

			if (restData.status === "error") {
				throw new Error(restData?.message);
			}
			// joining tydata and lydata based on month_year
			let obj = {};
			lyData?.forEach((item) => {
				Object.keys(item).forEach((key) => {
					if (key !== xAxisMonthDataCol) {
						item[`ly_${key}`] = item[key];
						delete item[key];
					}
				});
				if (typeof obj[item[xAxisMonthDataCol]] === "object")
					obj[item[xAxisMonthDataCol]] = { ...obj[item[xAxisMonthDataCol]], ...item };
				else obj[item[xAxisMonthDataCol]] = item;
			});
			tyData?.forEach((item) => {
				Object.keys(item).forEach((key) => {
					if (key !== xAxisMonthDataCol) {
						item[`ty_${key}`] = item[key];
						delete item[key];
					}
				});
				if (typeof obj[item[xAxisMonthDataCol]] === "object")
					obj[item[xAxisMonthDataCol]] = { ...obj[item[xAxisMonthDataCol]], ...item };
				else obj[item[xAxisMonthDataCol]] = item;
			});
			let joinedData = Object.values(obj);

			// add tyitem keys py_ prefix and for ly ly_

			setPageData(joinedData);
			setReportLoading(false);
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar((prev) => {
				return {
					...prev,
					message: parseErrMsgFromError(error),
					severity: "error",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				};
			});
		}
	};

	useEffect(() => {
		if (saleImDropdowns) {
			const relColumns = imFilterColumns?.filter(Boolean)?.map((col) => {
				if (col?.input_type === inputTypes.SELECT.key || col?.input_type === inputTypes.MULTIPLE_SELECT.key)
					return {
						...col,
						// constraints: { ...col.constraints, NOTNULL: false },
						[selectOptKeyName]: {
							type: arrType,
							list: saleImDropdowns,
						},
						input_type: col?.input_type === inputTypes.SELECT.key ? inputTypes.MULTIPLE_SELECT.key : col?.input_type,
					};
				else return col;
			});
			setImFilterColumns((prev) => {
				return relColumns?.sort((a, b) => a?.sort_no - b?.sort_no);
			});
		}
	}, [saleImDropdowns]);

	const getDropdownFields = async () => {
		try {
			const res = await getSaleImFields();
			setSaleImDropdowns(res);
			return res;
		} catch (error) {
			console.log(error);
			setSnackBarOpen(true);
			setSnackBar({
				...snackbar,
				message: "Unable to fetch Im Dropdowns",
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
		}
		return [];
	};

	useEffect(() => {
		getDropdownFields();
		fetch();
	}, []);

	const fetchImDropdownDataBasedonColumn = (column) => {
		return async (offset = 0, limit = 20, searchTerm = "") => {
			const query = {
				limit,
				offset,
			};
			if (searchTerm) query["search"] = searchTerm;
			// construct your request logic
			const res = await axios.get(`/api/reports/get-im-col-dropdowns-by-search/${column.key}`, {
				params: query,
				query: {},
			});

			return res;
		};
	};

	return (
		<Box position="relative">
			<Box
				display="flex"
				flexWrap="wrap"
				width="100%"
				alignItems="center"
				rowGap="5px"
				position="sticky"
				top="62px"
				left="0%"
				zIndex={1}
				bgcolor="white"
				boxSizing="border-box"
				boxShadow={2}
				borderRadius="4px"
				p={1}>
				<Box width="15%">
					<CustomDateRangePicker
						dateRange={dateRange}
						setDateRange={setDateRange}
						defaultDateRange={defaultDateRange}
						staticRanges={dateStaticRanges}
					/>
				</Box>
				<Box width="84%" pl={1}>
					<FilterDrawer
						filter={filter}
						setFilter={setFilter}
						drawerOpen={filterOpen}
						setDrawerOpen={setFilterOpen}
						columns={[...imFilterColumns, ...storeFilterColumns, ...locationFilterColumns, styleFilterCol]}>
						{/* {imFilterColumns?.map((col) => {
							return (
								<RenderInputField
									column={col}
									data={filter}
									setData={setFilter}
									selectOptObjName={"select_options"}
									width={"100%"}
									longWidth={"100%"}
									disabled={false}
								/>
							);
						})} */}
						{imFilterColumns ? (
							<Box display="flex" columnGap={"4%"} rowGap="10px" flexWrap="wrap" width="100%">
								<RenderAttributes
									columns={imFilterColumns ?? []}
									data={filter}
									setData={setFilter}
									errObj={{}}
									// setErrorObj={setErrorObj}
									allColumns={imFilterColumns}
									dependencyBasedOptFilterFun={removeDropdownOptionsBasedonDependency}
									selectOptObjName={selectOptKeyName}
									width="100%"
									longWidth="100%"
								/>
							</Box>
						) : (
							<></>
						)}
						<SearchInputFieldWithDebounce
							column={styleFilterCol}
							data={filter}
							setData={setFilter}
							fetchData={fetchImDropdownDataBasedonColumn(styleFilterCol)}
							selectOptKeyName={selectOptKeyName}
						/>
						<SearchInputFieldWithDebounce
							column={colorFilterCol}
							data={filter}
							setData={setFilter}
							fetchData={fetchImDropdownDataBasedonColumn(colorFilterCol)}
							selectOptKeyName={selectOptKeyName}
						/>
						<SearchInputFieldWithDebounce
							column={colorFilterCol}
							data={filter}
							setData={setFilter}
							fetchData={fetchImDropdownDataBasedonColumn(colorFilterCol)}
							selectOptKeyName={selectOptKeyName}
						/>
						<SearchInputFieldWithDebounce
							column={colorFilterCol}
							data={filter}
							setData={setFilter}
							fetchData={fetchImDropdownDataBasedonColumn(colorFilterCol)}
							selectOptKeyName={selectOptKeyName}
						/>
					</FilterDrawer>
				</Box>
			</Box>

			<Box display="flex" flexWrap="wrap" columnGap="4%" rowGap={2} pt={2}>
				{Object.keys(lineGraphTypes).map((key, i) => {
					return (
						<>
							<Box width="48%">
								{/* <LineGraphTwoLine
									data={pageData ?? []}
									width={600}
									height={250}
									column={lineGraphTypes[key]}
									key={key}
								/> */}
								<AreaGraphTwoLine
									data={pageData ?? []}
									width={600}
									height={250}
									column={lineGraphTypes[key]}
									key={key}
								/>
							</Box>
							{i > 0 && i % 2 !== 0 && <Divider sx={{ width: "100%" }} />}
						</>
					);
				})}
			</Box>
		</Box>
	);
};

export default SaleSummary;
